import React, { Component } from 'react';
import LayoutView from './Layout';
// import Header from './Layout/header';

export default class UserAdmin extends Component {
    render() {
        return (
            <LayoutView />
        )
    }
}
